<bn-loading-overlay></bn-loading-overlay>

<div class="row">
    <div class="col">
        <h5>SCR - Controle</h5>
    </div>
    <div class="col-right">
        <button type="button" class="btn btn-primary" (click)="atualizar()">Atualizar Progresso</button>
    </div>
</div>

<div class="container" *ngIf="controle">

    <div class="row">

        <div class="col-md-4">
            <label>Data do último arquivo de controle baixado:</label>
            <bn-datepicker [(ngModel)]="controle.dataHoraUltimoArquivoControleBaixado" [disabled]="true" name="dataHoraUltimoArquivoControleBaixado"></bn-datepicker>
        </div>

        <div class="col-md-4">
            <label>Data de início da execução atual:</label>
            <bn-datepicker [(ngModel)]="controle.dataHoraInicioCarga" [disabled]="true" name="dataHoraInicioCarga"></bn-datepicker>
        </div>

        <div class="col-md-4">
            <label>Usuário de início da execução atual:</label>
            <input type="text" class="form-control" [(ngModel)]="controle.loginCarga" [disabled]="true" name="loginCarga"/>
        </div>

    </div>

    <div class="row div-progresso" *ngIf="controle.dataHoraInicioCarga">
        <div class="col-md-12">
            <ngb-progressbar type="success" textType="white" [value]="getProgressoAtual()" [showValue]="true"></ngb-progressbar>
        </div>
    </div>


    <div class="row">
        <div class="table-responsive">
            <table class="table table-hover table-striped table-bordered">
                <thead>
                    <tr>
                        <th id="col-ano-mes-referencia" scope="col">
                            <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'anoMesReferencia'" [nomeAtributoExibicao]="'Data de referência'"
                              (aoClickar)="mudancaOrdenacao($event)">
                            </bn-ordenacao>
                        </th>                    

                        <th id="col-data-ultima-atualizacao-bacen" scope="col">
                            <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataUltimaAtualizacaoBacen'" [nomeAtributoExibicao]="'Data de última atualização no BACEN'"
                              (aoClickar)="mudancaOrdenacao($event)">
                            </bn-ordenacao>
                        </th>                    

                        <th id="col-data-ultima-atualizacao-BNDES" scope="col">
                            <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataUltimaAtualizacaoBNDES'" [nomeAtributoExibicao]="'Data de última atualização baixada'"
                              (aoClickar)="mudancaOrdenacao($event)">
                            </bn-ordenacao>
                        </th>                    

                        <th>Status</th>                  
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of controle.itens">
                        <ng-container *ngIf="item.anoMesReferencia >= 202007">
                            <td>{{ item.anoMesReferencia | bnMask:'ANOMES' }}</td>
                            <td>{{ item.dataUltimaAtualizacaoBacen | date:'dd/MM/yyyy' }}</td>
                            <td>{{ item.dataUltimaAtualizacaoBNDES | date:'dd/MM/yyyy' }}</td>
                            <td><i class="fas {{ item.dataUltimaAtualizacaoBNDES && item.dataUltimaAtualizacaoBacen <= item.dataUltimaAtualizacaoBNDES ? 'fa-check' : 'fa-times' }}"></i> </td>
                        </ng-container>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

</div>